module.exports = __webpack_public_path__ + "img/landing56.a82bd121.jpg";